import { get } from "utils/lodash";

export function createReducer(initialState, reducers) {
  return (state = initialState, action) => {
    const reducer = get(reducers, action.type);
    if (typeof reducer === "function") {
      return reducer(state, action);
    }
    return state;
  };
}

export default {
  createReducer,
};
